import React from 'react';
import { Grid, GridRow, GridItem } from './../Grid';
import { Text } from './../Typography';
import FadeInSection from '../FadeInSection';
import {
  Content,
  Super,
  StyledTitle,
  SocialContainer,
  SocialShare,
  SocialIconContainer,
  SocialIcon,
} from './styles';
import { ISocialMediaProps } from './types';

export const CorpSocialMedia = ({ data = {} }: { data: ISocialMediaProps | null | undefined }) => {
  return (
    <>
      {data && (
        <div
          data-test="socialmedia"
          data-print="hide"
          className={`py-20 ${data.color === 'peach' ? 'bg-corporate-peach' : 'bg-corporate-lightBlue'}`}
        >
          <Grid>
            <GridRow columns={16}>
              <GridItem colSpan={5} className="row-start-2 md:row-start-1">
                <Content>
                  <FadeInSection>
                    {data.super && (
                      <Super tag="div" type="leadxs" data-test="super">
                        {data.super}
                      </Super>
                    )}
                    {data.title && (
                      <StyledTitle tag="div" type="sm" data-test="title">
                        {data.title}
                      </StyledTitle>
                    )}
                    {data.socialMedia && (
                      <SocialContainer $isTwoColumns={data.socialMedia?.length! > 3}>
                        {data.socialMedia?.map((item: any, index: number) => {
                          return <SocialShare
                            href={item.url}
                            target="_blank"
                            data-test="share-link"
                            key={`social-${index}`}
                          >
                            {item?.assetsComponents[0]?.asset?.[0]?.url && (
                              <SocialIconContainer $isSmall={data.socialMedia?.length! > 3}>
                                <SocialIcon
                                  data-src={item?.assetsComponents[0]?.asset?.[0]?.url}
                                  alt=""
                                  className="lazyload"
                                />
                              </SocialIconContainer>
                            )}
                            <Text
                              tag="div"
                              type="md"
                              data-ec="follow us"
                              data-ea="click"
                              data-el={item?.name}
                              data-event_name="click_social_follow"
                              data-social_platform={item?.name}
                            >
                              {item?.name}
                            </Text>
                          </SocialShare>
                        })}
                      </SocialContainer>
                    )}
                  </FadeInSection>
                </Content>
              </GridItem>
            </GridRow>
          </Grid>
        </div>
      )}
    </>
  );
};
